<template>
    <div v-if="filterLoaded">
        <CardBase class="px-4 py-4">
            <div v-if="error" class="text-red-600 font-bold">
                <div class="underline">{{ $t('component.filter.error') }}</div>
                <ul class="mt-2 ml-4 list-disc" v-for="(f, i) in error" :key="i">
                    <li>{{ f.join(', ') }}</li>
                </ul>
            </div>

            <FilterCategory :title="$t('component.filter.group1.title')">

                <div class="w-64 relative">
                    <datepicker
                            input-class="block appearance-none bg-white border border-blue-200 text-gray-700 py-1 px-2 rounded leading-tight w-full"
                            :placeholder="$t('component.filter.group1.availability_date.placeholder')"
                            v-model="availability_date"
                            :language="lang"
                            format="dd.MM.yyyy"
                            :disabled-dates="yesterday"
                            :highlighted="highlighted"/>
                    <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <CalendarSVG></CalendarSVG>
                    </div>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group2.title')">
                <div>
                    <input v-model="one_patient" type="checkbox" id="one_patient"><label for="one_patient"> {{
                    $t('component.filter.group2.one_patient') }}</label>
                    <select :placeholder="$t('component.filter.group2.gender_option')" v-model="gender_option"
                            class="border text-gray-600 ml-2">
                        <option :value="null">{{ $t('component.filter.group2.gender_option') }}</option>
                        <option
                                v-for="(gender, index) in filter.gender_options"
                                :key="index"
                                :value="index">
                            {{ gender }}
                        </option>
                    </select>
                </div>
                <div class="pb-4"><input v-model="two_patients" type="checkbox" id="two_patients"> <label
                        for="two_patients"> {{ $t('component.filter.group2.two_patients') }}
                    <FilterEuroSymbol></FilterEuroSymbol>
                </label></div>
                <div class="border-t pt-4">
                    <div><input v-model="further_persons_household" type="checkbox" id="further_persons_household">
                        <label for="further_persons_household"> {{
                            $t('component.filter.group2.further_persons_household') }}
                            <FilterEuroSymbol></FilterEuroSymbol>
                        </label></div>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group3.title')">
                <div>
                    <input v-model="patients_fully_mobile" type="checkbox" id="patients_fully_mobile"> <label
                        for="patients_fully_mobile"> {{ $t('component.filter.group3.patients_fully_mobile')}} </label>
                </div>
                <div>
                    <input v-model="patients_wheelchair" type="checkbox" id="patients_wheelchair"><label
                        for="patients_wheelchair"> {{ $t('component.filter.group3.patients_wheelchair')}}</label>
                </div>
                <div>
                    <input v-model="patients_bedridden" type="checkbox" id="patients_bedridden"><label
                        for="patients_bedridden"> {{ $t('component.filter.group3.patients_bedridden')}}</label>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group4.title')">
                <div>
                    <input v-model="night_commitment_none" type="checkbox" id="night_commitment_none"><label
                        for="night_commitment_none"> {{ $t('component.filter.group4.night_commitment_none') }}</label>
                </div>
                <div>
                    <input v-model="night_commitment_once" type="checkbox" id="night_commitment_once"><label
                        for="night_commitment_once"> {{ $t('component.filter.group4.night_commitment_once') }}
                    <FilterEuroSymbol></FilterEuroSymbol>
                </label>
                </div>
                <div>
                    <input v-model="night_commitment_multiple" type="checkbox" id="night_commitment_multiple"><label
                        for="night_commitment_multiple"> {{ $t('component.filter.group4.night_commitment_multiple') }}
                    <FilterEuroSymbol></FilterEuroSymbol>
                </label>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group5.title')" last="true">
                <div>
                    <input v-model="dementia_no" type="checkbox" id="dementia_no"><label for="dementia_no"> {{
                    $t('component.filter.group5.dementia_no') }}</label>
                </div>
                <div>
                    <input v-model="dementia_yes" type="checkbox" id="dementia_yes"><label for="dementia_yes"> {{
                    $t('component.filter.group5.dementia_yes') }} </label>
                </div>
            </FilterCategory>
        </CardBase>

        <CardBase class="px-4 py-4">
            <FilterCategory :title="$t('component.filter.group6.title')">
                <div>
                    <select :placeholder="$t('component.filter.group6.compensation_option')"
                            v-model="compensation_option" class="w-64 border px-2 py-2">
                        <option :value="null">{{ $t('component.filter.group6.compensation_option') }}</option>
                        <option v-for="(compensation, index) in filter.compensation_options" :value="index"
                                :key="index">{{compensation}}
                        </option>
                    </select>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group7.title')">
                <div>
                    <select :placeholder="$t('component.filter.group7.location_option')" v-model="location_option"
                            class="w-64 border px-2 py-2">
                        <option :value="null">{{ $t('component.filter.group7.location_option') }}</option>
                        <optgroup
                                v-for="(locationGroup, index) in filter.location_options"
                                :key="index"
                                :value="index"
                                :label="locationGroup.name"
                        >
                            <option v-for="(location, index) in locationGroup.options"
                                    :key="index"
                                    :value="index"
                            >
                                {{ location }}
                            </option>
                        </optgroup>
                    </select>

                    <div @click="showMap" class="inline">
                        <QuestionSVG class="inline cursor-pointer fill-current text-gray-800 ml-2"/>
                    </div>
                    <!--<select class="inline w-32 ml-4 border px-2 py-2">
                        <option>Umkreis</option>
                    </select>-->
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group8.title')">
                <div>
                    <input v-model="environment_urban" type="checkbox" id="environment_urban"> <label
                        for="environment_urban">
                    {{ $t('component.filter.group8.environment_urban') }}</label>
                </div>
                <div>
                    <input v-model="environment_rural" type="checkbox" id="environment_rural"> <label
                        for="environment_rural">
                    {{ $t('component.filter.group8.environment_rural') }}</label>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group9.title')">
                <div>
                    <input v-model="car_required_no" type="checkbox" id="car_required_no"><label for="car_required_no">
                    {{ $t('component.filter.group9.car_required_no') }}</label>
                </div>
                <div>
                    <input v-model="car_required_yes" type="checkbox" id="car_required_yes"><label
                        for="car_required_yes"> {{ $t('component.filter.group9.car_required_yes') }}</label>
                </div>
            </FilterCategory>

            <FilterCategory :title="$t('component.filter.group10.title')" last="true">
                <div class="flex">
                    <div class="w-1/2">
                        <div>
                            <input v-model="building_type_house" type="checkbox" id="building_type_house"><label
                                for="building_type_house">
                            {{ $t('component.filter.group10.building_type_house') }}</label>
                        </div>
                        <div>
                            <input v-model="building_type_apartment" type="checkbox" id="building_type_apartment"><label
                                for="building_type_apartment">
                            {{ $t('component.filter.group10.building_type_apartment') }}</label>
                        </div>
                    </div>

                    <div class="w-1/2">
                        <div>
                            <input v-model="own_room" type="checkbox" id="own_room"><label for="own_room">
                            {{ $t('component.filter.group10.own_room') }}</label>
                        </div>
                        <div>
                            <input v-model="own_toilet" type="checkbox" id="own_toilet"><label for="own_toilet">
                            {{ $t('component.filter.group10.own_toilet') }}</label>
                        </div>
                    </div>
                </div>
            </FilterCategory>

        </CardBase>

        <div class="mt-5 mx-2">
            <button @click="search"
                    class="bg-blue-500 w-full py-1 text-white font-bold text-lg">
                <SearchSVG/>
                {{ $t('component.filter.search') }}
            </button>
        </div>

        <Portal to="modals">
            <EmptyModalBase v-if="isMapVisible" @close="isMapVisible = false">
                <img src="@/assets/karte.png">
            </EmptyModalBase>
        </Portal>
    </div>
</template>

<script>
    import CardBase from "@/components/shared/CardBase";
    import FilterCategory from "@/components/shared/FilterCategoryBase";
    import FilterEuroSymbol from "@/components/shared/symbols/FilterEuroSymbol";
    import CalendarSVG from "@/components/shared/svgs/CalendarSVG";
    import Datepicker from 'vuejs-datepicker';
    import {de, pl} from 'vuejs-datepicker/dist/locale'
    import {Portal} from 'portal-vue';
    import {mapGetters} from 'vuex';
    import SearchSVG from "../components/shared/svgs/SearchSVG";
    import UserService from "../services/user.service";
    import QuestionSVG from "../components/shared/svgs/QuestionSVG";
    import EmptyModalBase from "../components/shared/EmptyModalBase";

    export default {
        components: {
            EmptyModalBase,
            QuestionSVG,
            SearchSVG,
            FilterEuroSymbol,
            FilterCategory,
            CardBase,
            CalendarSVG,
            Datepicker,
            Portal
        },
        data() {
            return {
                isMapVisible: false,
                error: '',
                highlighted: {
                    dates: [
                        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                    ],
                    includeDisabled: true
                },

                availability_date: "",

                one_patient: false,
                two_patients: false,

                further_persons_household: false,

                patients_fully_mobile: false,
                patients_wheelchair: false,
                patients_bedridden: false,

                night_commitment_none: false,
                night_commitment_once: false,
                night_commitment_multiple: false,

                dementia_no: false,
                dementia_yes: false,

                environment_urban: false,
                environment_rural: false,

                car_required_no: false,
                car_required_yes: false,

                building_type_apartment: false,
                building_type_house: false,

                own_room: false,
                own_toilet: false,

                compensation_option: 0,
                gender_option: 0,
                location_option: 0,
            }
        },
        computed: {
            yesterday() {
                let yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return {
                    to: yesterday
                };
            },
            ...mapGetters('auth', {
                filterLoaded: 'filterLoaded',
                filter: 'filter',
                'loggedIn': 'loggedIn'
            }),
            ...mapGetters('mission', {
                getAvailabilityDate: 'GET_ANONYMIZED_AVAILABILITY_DATE'
            }),
            lang() {
                if (this.$i18n.locale === 'de') {
                    return de;
                } else if (this.$i18n.locale === 'pl') {
                    return pl;
                }

                return de;
            }
        },
        async mounted() {

            if (this.loggedIn) {
                await this.$store.dispatch('auth/filter');
                await this.$store.dispatch('mission/filter');
            } else {
                await this.$store.dispatch('auth/anonymisedFilter');
                await this.$store.dispatch('mission/anonymisedFilter');
            }

            if (this.loggedIn) {
                this.availability_date = this.filter.filter.availability_date;
            } else {
                this.availability_date = this.getAvailabilityDate;
            }


            this.building_type_apartment = this.filter.filter.building_type_apartment;
            this.building_type_house = this.filter.filter.building_type_house;
            this.car_required_no = this.filter.filter.car_required_no;
            this.car_required_yes = this.filter.filter.car_required_yes;
            this.compensation_option = this.filter.filter.compensation_option;
            this.dementia_no = this.filter.filter.dementia_no;
            this.dementia_yes = this.filter.filter.dementia_yes;
            this.environment_rural = this.filter.filter.environment_rural;
            this.environment_urban = this.filter.filter.environment_urban;
            this.further_persons_household = this.filter.filter.further_persons_household;
            this.gender_option = this.filter.filter.gender_option;
            this.location_option = this.filter.filter.location_option;
            this.night_commitment_multiple = this.filter.filter.night_commitment_multiple;
            this.night_commitment_none = this.filter.filter.night_commitment_none;
            this.night_commitment_once = this.filter.filter.night_commitment_once;
            this.one_patient = this.filter.filter.one_patient;
            this.own_room = this.filter.filter.own_room;
            this.own_toilet = this.filter.filter.own_toilet;
            this.patients_bedridden = this.filter.filter.patients_bedridden;
            this.patients_fully_mobile = this.filter.filter.patients_fully_mobile;
            this.patients_wheelchair = this.filter.filter.patients_wheelchair;
            this.two_patients = this.filter.filter.two_patients;
        },
        methods: {

            showMap() {
                this.isMapVisible = true;
            },
            async search() {
                try {
                    if (typeof this.availability_date !== 'string') {
                        this.availability_date = this.availability_date.toISOString().slice(0, 10)
                    }

                    await this.$store.dispatch('mission/resetSearch');

                    let filterOptions = {
                        availability_date: this.availability_date,
                        one_patient: this.one_patient,
                        two_patients: this.two_patients,
                        further_persons_household: this.further_persons_household,
                        patients_fully_mobile: this.patients_fully_mobile,
                        patients_wheelchair: this.patients_wheelchair,
                        patients_bedridden: this.patients_bedridden,
                        night_commitment_none: this.night_commitment_none,
                        night_commitment_once: this.night_commitment_once,
                        night_commitment_multiple: this.night_commitment_multiple,
                        dementia_no: this.dementia_no,
                        dementia_yes: this.dementia_yes,
                        environment_urban: this.environment_urban,
                        environment_rural: this.environment_rural,
                        car_required_no: this.car_required_no,
                        car_required_yes: this.car_required_yes,
                        building_type_apartment: this.building_type_apartment,
                        building_type_house: this.building_type_house,
                        own_room: this.own_room,
                        own_toilet: this.own_toilet,
                        compensation_option: this.compensation_option,
                        gender_option: this.gender_option,
                        location_option: this.location_option
                    };

                    if (this.loggedIn) {
                        await UserService.setFilter(
                            this.availability_date,
                            this.one_patient,
                            this.two_patients,
                            this.further_persons_household,
                            this.patients_fully_mobile,
                            this.patients_wheelchair,
                            this.patients_bedridden,
                            this.night_commitment_none,
                            this.night_commitment_once,
                            this.night_commitment_multiple,
                            this.dementia_no,
                            this.dementia_yes,
                            this.environment_urban,
                            this.environment_rural,
                            this.car_required_no,
                            this.car_required_yes,
                            this.building_type_apartment,
                            this.building_type_house,
                            this.own_room,
                            this.own_toilet,
                            this.compensation_option,
                            this.gender_option,
                            this.location_option);

                        await this.$store.dispatch('mission/setFilter', filterOptions);
                        await this.$store.dispatch('mission/missions');
                    } else {
                        await this.$store.commit('mission/SET_ANONYMIZED_AVAILABILITY_DATE', this.availability_date);
                        await this.$store.dispatch('mission/setFilter', filterOptions);
                        await this.$store.dispatch('mission/anonymizedMissions');
                    }
                    scrollTo(0, 0);
                    await this.$router.push({name: 'missions'}).catch((error) => {
                        console.log(error);
                    });
                } catch (error) {
                    console.log(error);
                    this.error = error.message;
                }
            }
        }
    }
</script>

<style scoped>

</style>